import "../sellscreendialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import { showTrainingModeActive } from "../../../../Actions/SellScreen/SellScreenActions";
import Button from "../../../../Common/Buttons/Button";
import NoTranslate from "../../../../Common/NoTranslate";
import { currency } from "../../../../Utilities/Generic/Numbers";
import { isTrainingMode } from "../../../../Utilities/Platform/Options/Options";

const connector = connect();

interface Props extends ConnectedProps<typeof connector> {
    dispatch: ThunkDispatch<any, any, any>;
    cashout: Array<{
        name?: string;
        amount: number;
    }>;
    hasChange: boolean;
    hasRefund: boolean;
}

class Cashout extends React.Component<Props> {
    protected closeDialog = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.stopPropagation();

        if(isTrainingMode()) {
            this.props.dispatch(showTrainingModeActive());
        } else {
            this.props.dispatch(hideDialog());
        }
    };

    public render(): React.ReactNode {
        let total = 0;

        let title;

        if(this.props.hasRefund && this.props.cashout.length === 1) {
            title = "refund";
        } else if(this.props.hasChange && this.props.cashout.length === 1) {
            title = "change";
        } else if(this.props.hasChange && this.props.hasRefund && this.props.cashout.length === 2) {
            title = "refund and change";
        } else {
            title = "cash out";

            if(this.props.hasChange) {
                title = `${title} and change`;
            }

            if(this.props.hasRefund) {
                title = `${title} and refund`;
            }
        }

        return (
            <div className="give-cashout">
                {isTrainingMode() && (
                    <p
                        style={{
                            fontWeight: "bold",
                            fontSize  : "1.5rem",
                        }}
                    >
                        You&apos;re in training mode. <br />
                        Do NOT provide the customer any cash.
                    </p>
                )}
                <p>Have you given the {title}?</p>
                {this.props.cashout.map((cashout, index) => {
                    const amount = cashout.amount;

                    total += amount;

                    return (
                        <div key={index} className="give-cashout-line">
                            <span>{cashout.name}</span>
                            <span className="amount"><NoTranslate>{currency(amount)}</NoTranslate></span>
                        </div>
                    );
                })}
                {
                    this.props.cashout.length > 1 && (
                        <div className="give-cashout-line total">
                            <span>Total</span>
                            <span className="amount"><NoTranslate>{currency(total)}</NoTranslate></span>
                        </div>
                    )
                }
                <div className="buttons">
                    <Button
                        type="button"
                        classes={[ "add-button" ]}
                        onClick={this.closeDialog}
                    >
                        Yes
                    </Button>
                </div>
            </div>
        );
    }
}

export default connector(Cashout);
